import React from "react";
import TradeApplication from "../../components/TradeApplication";

const TradeApplicationPage = ({ genericPageContent }) => (
  <TradeApplication genericPageContent={genericPageContent} />
);

export default TradeApplicationPage;
